module.exports = __webpack_public_path__ + "static/media/HomeOutcomeProgramValidation.3eb35eb7.jpg";